import { render, staticRenderFns } from "./intermission.vue?vue&type=template&id=52ae48dd"
import script from "./intermission.vue?vue&type=script&lang=js"
export * from "./intermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports